import { Swiper, Navigation, Pagination, Autoplay, Thumbs } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let mainBanner = new Swiper(".main-banner__slider", {
        watchOverflow: true,
        pagination: {
            el: ".main-banner__pagination",
            type: "bullets",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
        },
        speed: 600,
    });

    let aboutSlider = new Swiper(".about__slider", {
        watchOverflow: true,
    });

    let projectsSlider = new Swiper(".projects__slider", {
        watchOverflow: true,
        slidesPerView: 3.5,
        spaceBetween: 30,
        navigation: {
            nextEl: '.projects-button-next',
            prevEl: '.projects-button-prev',
        },
        breakpoints: {
            600: {
                slidesPerView: 1.3,
            },
        },
    });

    const swiperThumbsGallery = new Swiper(".thumbs-gallery", {
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        pagination: {
            el: ".thumbs-pagination",
            clickable: true,
        },
    });

    const swiperGalleryMain = new Swiper(".gallery-main", {
        spaceBetween: 10,
        slidesPerView: 1,
        navigation: {
            nextEl: ".gallery-next",
            prevEl: ".gallery-prev",
        },
        thumbs: {
            swiper: swiperThumbsGallery,
        },
        breakpoints: {
            480: {
                slidesPerView: 1.3,
            },
        },
    });

    let swiperLineTemp = new Swiper(".swiper__line-temp", {
        watchOverflow: true,

        navigation: {
            nextEl: ".line-temp-button-next",
            prevEl: ".line-temp-button-prev",
        },
        slidesPerView: 4.2,
        spaceBetween: 16,
        breakpoints: {
            600: {
                slidesPerView: 1.2,
                spaceBetween: 16,
            },
            900: {
                slidesPerView: 2.2,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 4.2,
                spaceBetween: 16,
            },
        },
    });

    let sliderAbout = new Swiper(".slider-about", {
        navigation: {
            nextEl: ".about-button-next",
            prevEl: ".about-button-prev",
        },
        pagination: {
            el: ".about__pagination",
            clickable: true,
        },
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        watchOverflow: true,
    });

    const sliderResidence = new Swiper(".slider-residence", {
        watchOverflow: true,
        navigation: {
            nextEl: ".residence-button-next",
            prevEl: ".residence-button-prev",
        },
        slidesPerView: 4,
        spaceBetween: 32,
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 32,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
        pagination: {
            el: ".residence-pagination",
            clickable: true,
        },
    });

    let aboutContentSlider = new Swiper(".about-content__slider", {
        watchOverflow: true,
    });
};
